import { ReloadOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { makeAutoObservable } from "mobx";
import * as React from "react";
import { appStore } from "src/appStore";
import { catalogsLoader } from "src/business/catalog/apiCatalog";
import { catalogColumns } from "src/business/catalog/catalogColumns";
import { ZCatalog } from "src/business/catalog/ZCatalog";
import { onError } from "src/common/onError";
import { MdmTable } from "src/components/MdmTable";
import { PageLayout } from "src/components/PageLayout";
import { RtColumnsSettingsButton } from "src/components/ReactiveTable/components/RtColumnsSettings";
import { RtStore } from "src/components/ReactiveTable/RtStore";
import { ToolBox2 } from "src/components/ToolBox2";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";

export const CatalogsPage: React.FC = () => {
  const tools = (
    <>
      <RtColumnsSettingsButton store={pageStore.table} />
      <Button
        icon={<ReloadOutlined />}
        onClick={() => pageStore.table.reload().catch(onError)}
      />
    </>
  );
  return (
    <PageLayout title="Каталоги">
      <ToolBox2 extraTools={tools} paddingMode="page">
        <MdmTable
          store={pageStore.table}
          columns={pageStore.columns}
          resizableColumns
          rowClick={{
            type: "link",
            builder: (row) => makeUrl(PageUrl.records, { id: row.id }),
          }}
        />
      </ToolBox2>
    </PageLayout>
  );
};

const pageStore = makeAutoObservable({
  table: new RtStore<ZCatalog, {}>({
    rowKey: "id",
    loader: catalogsLoader(),
  }),
  get columns() {
    return catalogColumns({ showScheme: false, settings: this.showSettings });
  },
  get showSettings(): boolean {
    return !!appStore.isMetadataEditor;
  },
});
